module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <h3>Detalhes</h3>\n    </div>\n    <div class=\"panel-body\">\n        <app-trabalho-detail trab_id={{trab_id}} ></app-trabalho-detail>\n        <app-avaliacao trab_id={{trab_id}} aval_id=0 setdisabled={{ver}}></app-avaliacao>\n\t\t<app-avaliacao *ngIf='ver' trab_id={{trab_id}} aval_id=1 setdisabled={{ver}}></app-avaliacao>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/avaliacao-detail/avaliacao-detail.component.html
// module id = ./src/app/avaliacao-detail/avaliacao-detail.component.html
// module chunks = main